import { useMemo } from 'react'
import type { PlayerAnimationState } from '@/types/Animation.types'

/**
 * Creates a map of route IDs to their current progress values.
 * Memoized for performance to avoid recreating the map on every render.
 *
 * @param playerStates - Array of player animation states
 * @returns Map of route ID to progress (0-1)
 *
 * @example
 * const routeProgress = useRouteProgressMap(animationState.playerStates)
 * const progress = routeProgress.get(drawingId) ?? 0
 */
export function useRouteProgressMap(
	playerStates: PlayerAnimationState[],
): Map<string, number> {
	return useMemo(() => {
		const map = new Map<string, number>()
		for (const playerState of playerStates) {
			if (playerState.routeId) {
				map.set(playerState.routeId, playerState.progress)
			}
		}
		return map
	}, [playerStates])
}
